const propertyOverrideActionsType = {
    add: "Add",
    replace: "Replace",
    delete: "Delete"
}

export default propertyOverrideActionsType;